import { DialogProps, GROUP_ACTIONS } from "components/Actions/types";

import ManageGroup from "../ManageGroup";

const CreateGroup = ({ isOpen, close }: DialogProps) => {
    return (
        <ManageGroup
            action={GROUP_ACTIONS.CreateGroup}
            isOpen={isOpen}
            close={close}
        />
    );
};

export default CreateGroup;
